import React from 'react'
import {connect} from 'react-redux'

import config from '../../config.js'

import 'Skelet/src/start.css'; // importing this seems to make it get stuck, so even on other routes and containers the css is still there.

import {toggleDropdown} from 'Skelet/src/modules/functions.js'
import CompanyFooter from 'Skelet/src/components/Company_Footer.js';
import StartFooter from 'Skelet/src/components/Start_Footer.js'


class StartRoute extends React.Component {

  constructor(props) {
    super(props);

    this.state = {is_scrolling:false};
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(e) {
    if(window.pageYOffset === 0) {
      this.setState({is_scrolling:false});
    } else if(!this.state.is_scrolling) {
      this.setState({is_scrolling:true});
    }
  }

  render() {
    const Header = () => <header className="scrolling" style={{display:(this.state.is_scrolling) ? "block" : "none"}}><div className="container wrap wrap-full">
      <div className="primary">
        <a href="/" onClick={() => document.getElementById("main").scrollIntoView(true)} className="logo text">Ghostin.nl</a>
      </div>
      <div className="secondary">
            <nav className="navigation">
              <ol>
                <li className="md-shown nav-item"><a href="/" onClick={() => document.getElementById("main").scrollIntoView(true)} className="btn btn-offset btn-fat">Start</a></li>
                <li className="md-shown nav-item"><a href="/#over" className="btn btn-offset btn-fat">Over Peter</a></li>
                <li className="md-shown nav-item"><a href="/testimonials" className="btn btn-offset btn-fat">Testimonials</a></li>
                <li className="md-shown nav-item"><a href="/artikelen" className="btn btn-offset btn-fat">Artikelen</a></li>
                <li className="md-shown nav-item"><a href="/diensten" className="btn btn-offset btn-fat">Diensten</a></li>
                <li className="md-shown nav-item"><a href="/portfolio" className="btn btn-offset btn-fat">Portfolio</a></li>
                <li className="md-shown nav-item"><a href="/contact" className="btn btn-offset btn-fat">Contact</a></li>
                <li className="md-shown nav-item"><a href="https://www.linkedin.com/in/peterdotplus/" target="blank" className="btn btn-offset btn-fat btn-if btn-if-gold" style={{boxShadow:"3px 3px black"}}>Online gesprek plannen</a></li>
                <li className={"md-hidden nav-item dropdown" + ((this.state.dropdown_open) ? " open" : "")} ref={this.setWrapperRef}>
                  <a href="/" onClick={(e) => toggleDropdown(this, e)}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{height:"32px"}}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" /></svg></a>
                  <div className="dropdown-menu">
                    <div className="dropdown-caret">
                      <span className="caret-outer"></span>
                      <span className="caret-inner"></span>
                    </div>
                    <ul style={{textAlign:"center"}}>
                      <li className="nav-item"><a href="/" onClick={() => {toggleDropdown(this);document.getElementById("main").scrollIntoView(true);}} className="btn btn-offset btn-fat">Start</a></li>
                      <li className="nav-item"><a href="/#over" onClick={() => {toggleDropdown(this);}} className="btn btn-offset btn-fat">Over Peter</a></li>
                      <li className="nav-item"><a href="/testimonials" onClick={() => {toggleDropdown(this);}} className="btn btn-offset btn-fat">Testimonials</a></li>
                      <li className="nav-item"><a href="/artikelen" onClick={() => {toggleDropdown(this);}} className="btn btn-offset btn-fat">Artikelen</a></li>
                      <li className="nav-item"><a href="/diensten" onClick={() => {toggleDropdown(this);}} className="btn btn-offset btn-fat">Diensten</a></li>
                      <li className="nav-item"><a href="/portfolio" onClick={() => {toggleDropdown(this);}} className="btn btn-offset btn-fat">Portfolio</a></li>
                      <li className="nav-item"><a href="/contact" onClick={() => {toggleDropdown(this);}} className="btn btn-offset btn-fat">Contact</a></li>
                      <li className="nav-item"><a href="https://www.linkedin.com/in/peterdotplus/" target="blank" onClick={() => {toggleDropdown(this);}} className="btn btn-offset btn-fat btn-if btn-if-gold">Online gesprek plannen</a></li>
                    </ul>
                  </div>
                </li>
              </ol>
            </nav>
          </div>
    </div></header>;

    /*const HeaderCheck = () => <header className="scrolling" style={{display:(this.state.is_scrolling) ? "none" : "block", background:"#f2aa22", textAlign:"center", fontSize:"120%", padding:"7px 0"}}>
        Gratis Uitgebreide Profiel Analyse, <a href="https://www.linkedin.com/in/peterdotplus/" target="blank" style={{color:"#000", textDecoration:"underline"}}>stuur mij direct</a> een bericht!
      </header>;*/

    return (
      <div>
        <div className="start">
          <main>
            {!this.props.hideheader && <Header />}
            {/*<HeaderCheck />*/}
            {/*<Route {...this.props} abc="def" />
            this doesn't pass the props, except for the [this.props], which are passed down from app.js
            cloneElement crashes because of an undefined error, even though it does work with CREATEelement.. */}
            {React.createElement(this.props.component, {
              config,
              session_token: this.props.session_token
            })}
            {/*this.props.children && React.cloneElement(this.props.children, {
              openModal: this.openModal
            })*/}
          </main>
          <CompanyFooter site="Ghostin" sitemap={{"Start":"/", "Over Peter":"/#over", "Testimonials":"/testimonials", "Artikelen":"/artikelen", "Diensten":"/diensten", "Portfolio":"/portfolio", "Contact":"/contact"}} />
          <StartFooter />
        </div>
      </div>
    );
  }

}


function mapStateToProps(state, ownProps) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    // pathname: ownProps.location.pathname
  }
}

export default connect(mapStateToProps, null)(StartRoute)



// WEBPACK FOOTER //
// ./src/containers/route-containers/StartRoute.js